import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { declareClientPackage, RuntimeDetails } from '@ClientBase/IClientPackage'
import { HandleReactComponentRendering } from '@ClientBase/React/RenderReactComponents'
import { PostFiltersEventHandler } from '@ClientBase/Generic/PostFiltersEventHandler'
import * as Carousels from './Carousels'
import * as Footer from './Footer'
import * as JobTile from './Jobs/Tile'
import * as JobFilters from './Jobs/Filters'
import * as Modal from './Modal'
import * as Navigation from './Navigation'
import * as PostTile from './PostTile'
import * as SearchOverlay from './SearchOverlay'
import * as SocialProfile from './SocialProfileWidget'
import * as StickyApply from './StickyApply'
import * as VideoSnippet from './VideoSnippet'
import * as PostAlertSignup from './PostAlertSignup'
import * as DisclaimerBanner from './DisclaimerBanner'
import * as JobAlertsForm from './JobAlertsForm'
import SnippetAccordionReact from './Accordion/Accordion'
import SnippetContent from './Content/Content'
import SnippetContentColumn from './ContentColumn/ContentColumn'
import SnippetIconsText from './IconsText/IconsText'
import SnippetImage from './Image/Image'
import SnippetImageContent from './ImageContent/ImageContent'
import SnippetHeading from './Heading/Heading'
import SnippetLinkBox from './LinkBox/LinkBox'
import SnippetSpacer from './Spacer/Spacer'
import SnippetTabSwitcher from './TabSwitcher/TabSwitcher'
import SnippetVideo from './Video/Video'
import SnippetParagraph from './Paragraph/Paragraph'
import SnippetSingleLink from './SingleLink/SingleLink'
import SnippetStatistic from './Statistic/Statistic'
import SnippetBrandsCarousel from './BrandsCarousel/BrandsCarousel'
import SnippetCareers from './Careers/Careers'
import SnippetUniversityProfile from './UniversityProfile/UniversityProfile'
import SnippetRepeatableImageContent from './RepeatableImageContent/RepeatableImageContent'
import SnippetLatestJobs from './LatestJobs/LatestJobs'
import SnippetInstitution from './Institution/Institution'
import SnippetLinksContent from './LinksContent/LinksContent'
import SnippetAwards from './Awards/Awards'
import * as PostResults from './PostResults'
/**
 * Extend the ClientBase class so you can benefit from any event hooks that Attrax offers,
 * and so that Attrax knows you have defined specific methods
 */

const _Components = {
    'SnippetAccordion' : SnippetAccordionReact,
    'SnippetContent' : SnippetContent,
    'SnippetContentColumn': SnippetContentColumn,
    'SnippetIconsText' : SnippetIconsText,
    'SnippetImage': SnippetImage,
    'SnippetImageContent': SnippetImageContent,
    'SnippetHeading': SnippetHeading,
    'SnippetLinkBox': SnippetLinkBox,
    'SnippetSpacer': SnippetSpacer,
    'SnippetTabSwitcher': SnippetTabSwitcher,
    'SnippetVideo' : SnippetVideo,
    'SnippetParagraph': SnippetParagraph,
    'SnippetSingleLink': SnippetSingleLink,
    'SnippetStatistic': SnippetStatistic,
    'SnippetBrandsCarousel': SnippetBrandsCarousel,
    'SnippetCareers': SnippetCareers,
    'SnippetUniversityProfile': SnippetUniversityProfile,
    'SnippetRepeatableImageContent': SnippetRepeatableImageContent,
    'SnippetLatestJobs': SnippetLatestJobs,
    'SnippetInstitution': SnippetInstitution,
    'SnippetLinksContent': SnippetLinksContent,
    'SnippetAwards': SnippetAwards,
}

declareClientPackage({
    onCmsSnippetPreview() {
        HandleReactComponentRendering(React, ReactDOM, _Components)
    },
    onDocumentReady(details: RuntimeDetails) {
        HandleReactComponentRendering(React, ReactDOM, _Components)
        Navigation.initialise()
        PostFiltersEventHandler.useAttraxTShandler($)
        JobTile.initialise()
        JobFilters.initialise()
        PostTile.makePostTileClickable()
        Carousels.initialise()
        VideoSnippet.VideoClickHandler()
        StickyApply.initialise()
        SocialProfile.initialise()
        Footer.FooterHandlers()
        SearchOverlay.initialise()
        Modal.initialise()
        PostResults.handlePostResultsUI()
        PostAlertSignup.handlePostAlertSignup()
        DisclaimerBanner.initNotificationBanner();
        JobAlertsForm.scrollToStep2()
        $(document).on('job-filter-initialized', function () {
            (window as any).jobFilterNoReloadController.enableDefaultFilterCounts()
        })
    },
})